import { render, staticRenderFns } from "./BotPartBubble.vue?vue&type=template&id=47810ccb&scoped=true"
import script from "./BotPartBubble.vue?vue&type=script&lang=js"
export * from "./BotPartBubble.vue?vue&type=script&lang=js"
import style0 from "./BotPartBubble.vue?vue&type=style&index=0&id=47810ccb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47810ccb",
  null
  
)

export default component.exports